import { gql } from '@apollo/client'

export const ALL_QUESTIONS = gql`
  query getAllQuestions($patteristoId: String!, $language: String) {
    collection(data: { id: $patteristoId, language: $language }) {
      id
      nimi
      versio
      kysymykset {
        id
        index
        otsikko
        aliotsikko
        kysymys
        kieli
        sallittu_rooleille {
          id
          name
        }
        sallittu_kyselyissa
      }
    }
  }
`
